// Specchio di ems-be/src/utils/prodottiZone.js: chi scrive cosa su prodotti e varianti.
// Il server rifiuta (403) tutta la richiesta se contiene un campo fuori zona: il gestionale manda solo
// i campi delle zone dell'utente. Se cambia l'elenco sul server va cambiato anche qui.

export const SEZIONE_ACQUISTI = 'Articoli'
export const SEZIONE_VETRINA = 'E-commerce'

export const LINGUE = ['it', 'fr', 'en']
export const STATI = ['da_completare', 'online', 'ritirato']
const perLingua = (...campi) => campi.flatMap(c => LINGUE.map(l => `${c}_${l}`))

// Uguali su tutte le varianti: si modificano sul prodotto
export const DATI_COMUNI = ['produttore', 'fornitore', 'settore', 'iva', 'unitaMisura', 'daziCategoria', 'trasportoRef', 'trasporto2Ref', 'consegna']

export const CAMPI_PRODOTTO = {
  acquisti: ['nomeInterno', ...DATI_COMUNI],
  vetrina: [
    ...perLingua('nome', 'slug', 'descrizione', 'descrizioneBreve', 'tipoVariante', 'unitaVendita', 'metaTitle', 'metaDescription'),
    'categoria', 'inEvidenza', 'ordine'
  ]
}

const ETICHETTE = perLingua('etichetta')
export const CAMPI_VARIANTE = {
  acquisti: [
    ...ETICHETTE, ...perLingua('titolo'), 'referenza', 'barcode',
    'prezzoAcquisto', 'prezzoProduttore', 'valuta', 'costoContainer', 'containerValuta',
    'capacita_trasporto', 'tipoContainer', 'larghezza', 'profondita', 'altezza',
    'qtaMinStock', 'descrizione', 'deprecated'
  ],
  vetrina: [...ETICHETTE, 'immagini', 'visibile', 'ordine']
}

// `tutte`: le sezioni (da /sezioni); `mie`: gli id delle sezioni dell'utente
export function zoneDi (tutte, mie) {
  const titoli = new Set((tutte || []).filter(s => (mie || []).includes(s._id)).map(s => s.title))
  return [[SEZIONE_ACQUISTI, 'acquisti'], [SEZIONE_VETRINA, 'vetrina']].filter(([titolo]) => titoli.has(titolo)).map(([, zona]) => zona)
}

export const campiDi = (campi, zone) => [...new Set(zone.flatMap(z => campi[z] || []))]
